import decoration from './../../assets/img/deco.svg';

import uca_logo from './../../assets/img/logo_uca_azul.png';
import fialinks_logo from './../../assets/img/FiaLinks_logo.svg';

import { useTranslation } from 'react-i18next';
import html from 'html-react-parser'; 

const Footer = ({ showLogos = true }) => {
  const { t } = useTranslation();

  return (
    <footer className="bg-conia-dark text-conia-light flex flex-col">
      {
        showLogos &&
          <div className='p-4 flex flex-wrap gap-8 justify-center items-center bg-conia-light-alt child:flex-1 child:min-w-[200px] child:max-w-xs'>
            <a href='https://uca.edu.sv' target="_blank" rel="noreferrer">
              <img src={uca_logo} alt="Logo UCA"/>
            </a>
            
            <h2 className='text-center text-conia-dark text-xl'>
              { html(t("footer_slogan_text")) }
            </h2>

            <figure>
              <img src={fialinks_logo} alt="Logo Fia Links"/>
            </figure>
          </div>
      }

      <div className="w-full h-16 bg-cover bg-center"
        style={{ backgroundImage: `url(${decoration})` }}>

      </div>
      <div className="p-2 flex justify-center">
        <h4 className="text-center text-sm"> 
          Copyright © FIALinks 2022  
        </h4>
      </div>
    </footer>
  )  
}

export default Footer;